// Client mirror of functions-common/src/charts/engine/aggregate.ts. Keep in sync.

import type { ChartMeasure } from '../types.js'

export function computeAggregate(
  rows: Array<Record<string, unknown>>,
  measure: ChartMeasure
): number {
  if (measure.agg === 'count') {
    return rows.length
  }

  if (rows.length === 0) {
    return 0
  }

  const values: number[] = []
  const rawSet = new Set<unknown>()

  for (const row of rows) {
    const val = row[measure.field]
    if (measure.agg === 'distinct') {
      if (val != null) rawSet.add(val)
    } else {
      const num = Number(val)
      if (!Number.isNaN(num)) {
        values.push(num)
      }
    }
  }

  switch (measure.agg) {
    case 'distinct':
      return rawSet.size
    case 'sum':
      return values.reduce((sum, v) => sum + v, 0)
    case 'avg':
      if (values.length === 0) return 0
      return values.reduce((sum, v) => sum + v, 0) / values.length
    case 'min':
      return values.length > 0 ? Math.min(...values) : 0
    case 'max':
      return values.length > 0 ? Math.max(...values) : 0
    default:
      return rows.length
  }
}
